<template>
    <v-card flat elevation="0" class="bible-form" :loading="loading" max-height="700px">
        <v-card-title>
            <span class="header2">{{ dataGathering.title }}</span>
        </v-card-title>
        <v-card-subtitle>
            <span class="header3">Paso {{ step }}</span>
        </v-card-subtitle>
        <v-divider v-if="showDivider"></v-divider>
        <v-card-text ref="dialogContent">
            <v-container>
                <v-stepper class="progress-stepper" v-model="step">
                    <v-stepper-items>
                        <template v-for="(data, key1) in stepIndex">
                            <v-stepper-content :step="key1+1" :key="key1+1">
                                <v-row>
                                    <template v-for="(field, key2) in fields">
                                        <v-col :key="key2" v-if="field.step_index === data" cols="6" class="dialog-items">
                                            <span class="label">
                                               <label v-if="key2-1 > 0" style="font-weight: 600 !important;">
                                                   {{setFieldLabel(key2 - 1, field.short_title)}}
                                               </label>
                                                {{ field.title }}
                                            </span>
                                            <v-text-field v-model="currentDataRecord[field.id]"
                                                          v-if="field.type === 'string' && field.id !== 'academic_announcement'"
                                                          :type="getFieldType(field)"
                                                          outlined required hide-details="auto"
                                                          class="input-text input-text--text-field body-text" dense
                                                          @keydown="restrictInput($event, field.id)"
                                                          :min="field.id === 'take_times' ? 1 : null"
                                                          :rules="getFieldRules(field.id)"
                                                          :step="field.id === 'grade' ? '0.1' : null"/>
                                            <v-select v-model="currentDataRecord['academic_announcement']"
                                                      class='input-text input-text--select body-text'
                                                      hide-details dense :aria-required="true"
                                                      v-if="field.id === 'academic_announcement'"
                                                      :items="announcementsList" outlined/>
                                            <v-menu ref="menu" v-model="menu" offset-y min-width="auto"
                                                    :close-on-content-click="false"
                                                    :return-value="currentDataRecord[field.id]"
                                                    transition="scale-transition" v-if="field.type==='date'">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field v-model="modelFormattedDate.replace(/-/g,'/')"
                                                                  class="input-text input-text--text-field body-text"
                                                                  readonly dense outlined required hide-details="auto"
                                                                  v-bind="attrs" v-on="on"/>
                                                </template>
                                                <v-date-picker v-model="modelFormattedDate"
                                                               color="hsla(201, 100%, 41%, 1)" show-adjacent-months
                                                               no-title :locale="$t('app.language').toString()"
                                                               @input="updateDate">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text color="primary" @click="setDate">
                                                        OK
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                            <div style="padding-left: 8px;">
                                                <v-tooltip right v-if="showTooltip(field.id)">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <div v-on="on" v-bind="attrs" style="width: fit-content;">
                                                            <v-switch v-model="currentDataRecord[field.id]"
                                                                      style="margin-top: 0 !important;"
                                                                      class="input-text input-text--text-field body-text"
                                                                      dense
                                                                      :rules="getFieldRules(field)"
                                                                      :disabled="setDisabled(field)" required inset
                                                                      hide-details="auto"
                                                                      v-if="field.type === 'switch'"/>
                                                        </div>
                                                    </template>
                                                    <span>{{ getMessage(field.id) }}</span>
                                                </v-tooltip>
                                                <v-switch v-else-if="field.type === 'switch'"
                                                          v-model="currentDataRecord[field.id]"
                                                          style="margin-top: 0 !important;"
                                                          class="input-text input-text--text-field body-text"
                                                          dense :rules="getFieldRules(field)"
                                                          :disabled="setDisabled(field)" required inset
                                                          hide-details="auto"/>
                                            </div>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-stepper-content>
                        </template>
                    </v-stepper-items>
                </v-stepper>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="justify-content: space-between; padding-right: 34px; padding-left: 34px; flex-direction: row-reverse" >
            <div>
                <v-btn class="v-btn--secondary" @click="cancel" :disabled="loading" style="margin-right: 8px">
                    {{ $tc('data_gatherings.cancel') }}
                </v-btn>
                <v-btn v-if="step === stepIndex.length" :class="validation ? 'v-btn--primary' : 'v-btn--primary--disabled'" @click="save"
                       :disabled="loading">
                    {{ $tc('data_gatherings.save') }}
                </v-btn>
                <v-btn v-if="step < stepIndex.length" class="v-btn--primary" @click="step++">
                    Siguiente
                </v-btn>
            </div>
            <v-btn v-if="step > 1" class="v-btn--secondary" @click="step--" style="margin-left: 0px !important;">
                Volver
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { DataRecordsStore } from "@/Store/DataGatherings/DataRecordsStore";
import { mapState, mapWritableState, mapActions } from "pinia";
import ToastMixin from "@/Shared/toastMixin";

export default {
    props: {},
    mixins: [ToastMixin],
    data() {
        return {
            step: 1,
            loading: false,
            validation: true,
            moreContent: false,
            menu: false,
            showDivider: false,
            formattedDate: '',
            modelFormattedDate: '',
            rules: {
                moreThanZero: value => value > 0 || this.$t('bibles.validations.greater_than'),
                gradeRules: (value) => {
                    const regex = /^(\d+(\.\d+)?|\d+(\,\d+)?|R)$/;
                    return regex.test(value) || this.$t('bibles.validations.grades_validation')
                }
            },
            disabledSwitch: false,
            previousGrade: 0,
            enrollmentStatuses: ['approved', 'recognized', 'suspended', 'not_presented'],
            enrollmentTypes: ['first_enrollment', 'second_enrollment', 'third_enrollment', 'fourth_enrollment'],
            approved: true,
            announcementsList: ['Semestre 1','Semestre 2','Extraordinaria'],
        };
    },
    mounted() {
        const dialogContent = this.$refs.dialogContent;
        dialogContent.addEventListener("scroll", this.handleScroll);
    },

    beforeDestroy() {
        const dialogContent = this.$refs.dialogContent;
        dialogContent.removeEventListener("scroll", this.handleScroll);
    },

    watch: {
        'currentDataRecord.birth_date': {
            handler(newVal) {
                this.formattedDate = this.formatDate(newVal);
                this.modelFormattedDate = this.parseDate(this.formattedDate);
            },
            immediate: true,
        },

        // Business rules, set recognized = 1 another = 0
        'currentDataRecord.recognized'(newVal) {
            if (newVal) {
                this.currentDataRecord.approved = false;
                this.currentDataRecord.suspended = false;
                this.currentDataRecord.not_presented = false;
                this.currentDataRecord.enrollment_SIUU = false;
                this.currentDataRecord.grade === '' || this.currentDataRecord.grade === null
                    ? this.currentDataRecord.grade = 'R': this.currentDataRecord.grade;
                this.approved = false;
                this.showGradeNotification();
            }
        },

        // Business rules, set approved = 1 another = 0
        'currentDataRecord.approved'(newVal) {
            if (newVal) {
                this.currentDataRecord.recognized = false;
                this.currentDataRecord.suspended = false;
                this.currentDataRecord.not_presented = false;
                this.checkGrade(this.currentDataRecord.grade, this.dataGathering.type.abbr);
            } else {
                this.approved = true;
            }
        },

        // Business rules, set suspended = 1 another = 0
        'currentDataRecord.suspended'(newVal) {
            if (newVal) {
                this.currentDataRecord.recognized = false;
                this.currentDataRecord.approved = false;
                this.currentDataRecord.not_presented = false;
                this.checkGrade(this.currentDataRecord.grade, this.dataGathering.type.abbr);
            }
        },

        // Business rules, set not_presented = 1 another = 0
        'currentDataRecord.not_presented'(newVal) {
            if (newVal) {
                this.currentDataRecord.recognized = false;
                this.currentDataRecord.approved = false;
                this.currentDataRecord.suspended = false;
                this.currentDataRecord.grade = 0;
                this.approved = false;
                this.showGradeNotification();
            }
        },

        // Business rules, set enrollment_SIUU = 1 recognized = 0
        'currentDataRecord.enrollment_SIUU'(newVal) {
            if (newVal) {
                this.currentDataRecord.recognized = false;
            }
        },

        // Business rules, value takeTimes change enrollments
        'currentDataRecord.take_times'(newVal) {

            const takeTimes = parseInt(newVal);

            switch (takeTimes) {
                case 1:
                    this.currentDataRecord.first_enrollment = true;
                    this.currentDataRecord.second_enrollment = false;
                    this.currentDataRecord.third_enrollment = false;
                    this.currentDataRecord.fourth_enrollment = false;
                    break;
                case 2:
                    this.currentDataRecord.first_enrollment = false;
                    this.currentDataRecord.second_enrollment = true;
                    this.currentDataRecord.third_enrollment = false;
                    this.currentDataRecord.fourth_enrollment = false;
                    break;
                case 3:
                    this.currentDataRecord.first_enrollment = false;
                    this.currentDataRecord.second_enrollment = false;
                    this.currentDataRecord.third_enrollment = true;
                    this.currentDataRecord.fourth_enrollment = false;
                    break;
                case 4:
                default:
                    if (takeTimes >= 4) {
                        this.currentDataRecord.first_enrollment = false;
                        this.currentDataRecord.second_enrollment = false;
                        this.currentDataRecord.third_enrollment = false;
                        this.currentDataRecord.fourth_enrollment = true;
                    }
                    break;
            }
        },

        'currentDataRecord.first_enrollment'(newVal) {
            if (newVal)
                this.currentDataRecord.take_times = 1;
        },

        'currentDataRecord.second_enrollment'(newVal) {
            if (newVal)
                this.currentDataRecord.take_times = 2;
        },

        'currentDataRecord.third_enrollment'(newVal) {
            if (newVal)
                this.currentDataRecord.take_times = 3;
        },

        'currentDataRecord.fourth_enrollment'(newVal) {
            if (newVal)
                this.currentDataRecord.take_times = 4;
        }
    },

    computed: {
        stepIndex() {
            const isSurveyPath = window.location.pathname.includes('surveys');
            if (isSurveyPath) {
                let indexes = [...new Set(this.columns.map((data) =>{
                    data.id === 'program' ? data.step_index = 1 : data.step_index;
                    return data.step_index
                }))].filter(element => element !== 0);

                return indexes;
            }
            let indexes = [...new Set(this.columns.map(data => data.step_index))].filter(element => element !== 0);

            return indexes;
        },
        fields() {
            return this.columns;
        },

        ...mapState(DataRecordsStore, ['headers', 'columns', 'dataTableHeaders', 'showMoreEditHeaders', 'showLessEditHeaders']),

        ...mapWritableState(DataRecordsStore, ['currentDataRecord', 'dataGathering']),
    },

    methods: {
        onDataRecordSelected(dataRecord) {
            console.log(arguments);

            this.dataRecord = dataRecord;
        },

        onDataRecordUnselected() {
            this.dataRecord = {};
        },

        getFieldRules(field) {
            const rules = [];

            if (field === 'take_times') {
                rules.push(this.rules.moreThanZero);
            }

            if (field === 'grade') {
                rules.push(this.rules.gradeRules)
            }

            return rules;
        },

        getFieldType(field) {
            if (field === 'take_times' || field === 'credits') {
                return 'number';
            }
            return 'text';
        },

        convertFieldValues() {
            for (const key in this.currentDataRecord) {
                const value = this.currentDataRecord[key];

                if (value === null || value === undefined || value === '') {
                    continue;
                }

                if (key === 'identification_value') {
                    this.currentDataRecord[key] = String(value);
                    continue;
                }

                if (typeof value === 'string' && !isNaN(value)) {
                    const numValue = Number(value);
                    if (Number.isInteger(numValue)) {
                        this.currentDataRecord[key] = numValue;
                    } else if (!isNaN(parseFloat(value))) {
                        this.currentDataRecord[key] = parseFloat(value);
                    }
                }
            }
        },

        // Shows notification to watch the grade field
        showGradeNotification() {
            this.toast().warning(this.$t('data_records.check_grade'));
        },

        //Checks grade
        checkGrade(grade, type) {
            if (this.currentDataRecord['grade'] !== 'R') {
                if (this.currentDataRecord['approved']) {
                    if ((grade < 5 && type.includes('GRADE')) || (grade < 7 && type.includes('MASTER'))) {
                        this.approved = false;
                        this.showGradeNotification();
                        return;
                    }
                    this.approved = true;
                    return;
                }

                if (this.currentDataRecord['suspended']) {
                    if ((grade >= 5 && type.includes('GRADE')) || (grade >= 7 && type.includes('MASTER'))) {
                        this.approved = true;
                        this.showGradeNotification();
                        return;
                    }
                    this.approved = false;
                    return;
                }
            }
            this.showGradeNotification()
        },

        handleScroll() {
            const dialogContent = this.$refs.dialogContent;
            if (dialogContent) {
                this.showDivider = dialogContent.scrollTop > 1;
            }
        },

        save() {
            if (!window.location.pathname.includes('bibles')) {
                this.savingProcess();
                return;
            }

            if (this.currentDataRecord['take_times'] > 0) {
                this.checkGrade(this.currentDataRecord['grade'], this.dataGathering.type.abbr);
                if (!this.approved && this.currentDataRecord['suspended']) {
                    this.savingProcess();
                    return;
                }

                if (this.approved && !isNaN(this.currentDataRecord['grade']) &&this.currentDataRecord['approved']) {
                    this.savingProcess();
                    return;
                }

                if (this.currentDataRecord['grade'] === 'R' && this.currentDataRecord['recognized']) {
                    this.savingProcess();
                    return;
                }

                if (this.currentDataRecord['not_presented']) {
                    this.savingProcess();
                    return;
                }
            }
        },

        savingProcess() {
            this.loading = true;
            this.convertFieldValues();

            this.update(this.dataRecord)
                .catch()
                .then(() => {
                    this.loading = false;
                    this.$emit('save');
                });
        },

        cancel() {
            this.moreContent = false;
            this.$emit('cancel');
        },

        setFieldLabel(index, shortTitle) {
            const isSurveyPath = window.location.pathname.includes('surveys');
            return isSurveyPath ? `${index}) ${shortTitle} - ` : '';
        },

        formatDate(date) {
            if (!date) {
                return '';
            }

            const parsedDate = new Date(date);

            if (isNaN(parsedDate.getTime())) {
                return '';
            }

            const year = parsedDate.getUTCFullYear();
            const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
            const day = String(parsedDate.getUTCDate()).padStart(2, '0');

            return `${year}/${month}/${day}`;
        },

        parseDate(date) {
            if (!date) {
                return '';
            }

            const [year, month, day] = date.split('/');

            if (!year || !month || !day || year.length !== 4 || month.length !== 2 || day.length !== 2) {
                return '';
            }

            return `${year}-${month}-${day}`;
        },

        setDate() {
            this.modelFormattedDate = this.formatDate(this.currentDataRecord.birth_date);
            this.menu = false;
        },

        updateDate(date) {
            this.currentDataRecord.birth_date = this.formatDate(date);
        },

        setDisabled(field) {
            const conditions = {
                approved: () => !this.currentDataRecord.recognized &&
                    !this.currentDataRecord.suspended &&
                    !this.currentDataRecord.not_presented,

                recognized: () => !this.currentDataRecord.approved &&
                    !this.currentDataRecord.suspended &&
                    !this.currentDataRecord.not_presented,

                suspended: () => !this.currentDataRecord.approved &&
                    !this.currentDataRecord.recognized &&
                    !this.currentDataRecord.not_presented,

                not_presented: () => !this.currentDataRecord.approved &&
                    !this.currentDataRecord.suspended &&
                    !this.currentDataRecord.recognized,

                enrollment_SIUU: () => this.currentDataRecord.recognized,

                first_enrollment: () => !this.currentDataRecord.second_enrollment &&
                    !this.currentDataRecord.third_enrollment &&
                    !this.currentDataRecord.fourth_enrollment,

                second_enrollment: () => !this.currentDataRecord.first_enrollment &&
                    !this.currentDataRecord.third_enrollment &&
                    !this.currentDataRecord.fourth_enrollment,

                third_enrollment: () => !this.currentDataRecord.first_enrollment &&
                    !this.currentDataRecord.second_enrollment &&
                    !this.currentDataRecord.fourth_enrollment,

                fourth_enrollment: () => !this.currentDataRecord.first_enrollment &&
                    !this.currentDataRecord.second_enrollment &&
                    !this.currentDataRecord.third_enrollment,
            };

            return conditions[field.id] ? conditions[field.id]() : false;
        },

        showTooltip(field) {
            if (this.enrollmentStatuses.includes(field) || this.enrollmentTypes.includes(field)) return true;
            return false;
        },

        getMessage(field) {
            if (this.enrollmentStatuses.includes(field)) {
                return this.$t('bibles.validations.enrollmentStatuses');
            }
            if (this.enrollmentTypes.includes(field)) {
                return this.$t('bibles.validations.enrollmentTypes');
            }
        },

        // Restricts grade input value
        restrictInput(event, fieldValue) {
            if (fieldValue === 'grade') {
                const key = event.key;

                const regex = /^[\d\.R,]$/;

                const currentValue = this.currentDataRecord.grade + key;

                if (this.containsValidCharacter(currentValue)) {
                    event.preventDefault();
                    return;
                }

                if (!regex.test(key) && key !== "Backspace") {
                    event.preventDefault();
                }

            }
        },

        containsValidCharacter(value) {
            const containsNumber = /\d/.test(value);
            const containsR = /R/.test(value);
            return containsNumber && containsR;
        },

        ...mapActions(DataRecordsStore, ['update']),
    },

    created() {

    },
};
</script>

<style scoped lang="scss">
.dialog-items {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px !important;

    .v-input {
        align-items: flex-end !important;
    }
}

.bible-form-dialog .bible-form > .v-card__subtitle {
    padding: 21px 34px 0 !important;
}

::v-deep .v-date-picker-table {
    height: auto !important;
}

.v-stepper {
    box-shadow: none !important;
    background-color: inherit !important;
}

.v-stepper__items {
    background-color: inherit !important;
}

.v-stepper__content {
    padding: 0 !important;
}

</style>
